import React, { useContext } from 'react'
import LeftContent from 'modules/react/signup/LeftContent'
import RightContent from 'modules/react/signup/RightContent'
import SignupContext from 'modules/react/signup/SignupContext'
import FormElementError from 'modules/react/signup/FormElementError'
import CourseSummary from 'modules/react/signup/CourseSummary'
import CourseDateSelection from 'modules/react/signup/CourseDateSelection'
import NewsletterCheckbox from 'modules/react/signup/NewsletterCheckbox'

export default function Step2Unemployed () {

  const signupContext = useContext(SignupContext)
  const { goBack, goToNextStep, setFormValue, submit, restUrls, setEnterCallback } = signupContext

  React.useEffect(() => {
      setEnterCallback(() => validateStepData)
    }, []
  )

  React.useEffect(() => {
      setEnterCallback(() => validateStepData)
    }, []
  )

  const validateStepData = () => {
    submit(restUrls.unemployed.validate_personal)
      .then((response) => {
        goToNextStep()
      })
  }

  return (
    <>
      <LeftContent>
        <div className="title title--h3">Tilmelding af kursus</div>
        <div className="wysiwyg">Vælg startdato
          Her skal du vælge den ønskede startdato på dit kursus.
        </div>
        <CourseDateSelection/>
        <div className="title title--h6">Udfyld dine oplysninger</div>
        <div className="input-group">
          <div className="input-group__half">
            <div className="input-wrap">
              <FormElementError name="firstName">
                <input type="text" placeholder="Dit fornavn:" onChange={(e) => setFormValue('firstName', e.target.value)}/>
              </FormElementError>
            </div>
            <div className="input-wrap">
              <FormElementError name="lastName">
                <input type="text" placeholder="Dit efternavn:" onChange={(e) => setFormValue('lastName', e.target.value)}/>
              </FormElementError>
            </div>
          </div>
          <div className="input-wrap">
            <FormElementError name="cpr">
              <input type="text" placeholder="CPR-nr:"
                     onChange={(e) => setFormValue('cpr', e.target.value)}/>
            </FormElementError>
          </div>
          <div className="input-group__half">
            <div className="input-wrap">
              <FormElementError name="phone">
                <input type="text" placeholder="Dit telefonnr:"
                       onChange={(e) => setFormValue('phone', e.target.value)}/>
              </FormElementError>
            </div>
            <div className="input-wrap">
              <FormElementError name="email">
                <input type="text" placeholder="Din email:"
                       onChange={(e) => setFormValue('email', e.target.value.trim())}/>
              </FormElementError>
            </div>
          </div>
        </div>
        <NewsletterCheckbox/>
        <div className="button-section button-section--modal-group">
          <button className="inline-button inline-button--prim inline-button--back" onClick={goBack}>Tilbage</button>
          <button className="button button--next" onClick={validateStepData}>Næste</button>
        </div>
      </LeftContent>
      <RightContent>
        <CourseSummary paymentType="Egenbetaling"/>
      </RightContent>
    </>
  )
}